import type { LocalizationLanguage } from '@gov-nx/core/app/localization/languages';
import type { Nullable } from '@gov-nx/core/types/helpers.types';
import type { PageCode } from '@gov-nx/module/page/definitions/codes';
import type {
	SearchAllRecentVisited,
	SearchAllSearchTerms,
} from '@gov-nx/module/page/vysledky-vyhledavani/context.types';
import type { ServiceCode } from '@gov-nx/module/service/definitions/codes';

export type FavoriteCode = PageCode | ServiceCode | string;

interface UserSettingBase {
	key: CommonSettingKey;
	value: NastaveniApiValueType;
}

export interface UserSettingLanguage extends UserSettingBase {
	key: CommonSettingKey.Language;
	value: LocalizationLanguage;
}

export interface UserSettingFavorites extends UserSettingBase {
	key: CommonSettingKey.Favorites;
	value: FavoriteCode[];
}

export interface UserSettingSearchTerms extends UserSettingBase {
	key: CommonSettingKey.SearchTerms;
	value: SearchAllSearchTerms[];
}

export interface UserSettingRecentVisited extends UserSettingBase {
	key: CommonSettingKey.RecentVisited;
	value: SearchAllRecentVisited[];
}

export type UserSetting =
	| UserSettingLanguage
	| UserSettingFavorites
	| UserSettingSearchTerms
	| UserSettingRecentVisited;

export type FirebaseTokenPayload = {
	key: Nullable<string>;
	value?: string;
};

// NOTE: The keys used in storage are defined by us, so feel free to add new ones.
export enum CommonSettingKey {
	Favorites = 'oblibene',
	Language = 'jazyk',
	SearchTerms = 'hledane-vyrazy',
	RecentVisited = 'naposledy-navstivene',
}

// Generated NastaveniNastaveniDto is not correct, so we need to use following DTOs instead:
export type NastaveniApiValueType = string | number | boolean | null | object;

export interface NastaveniApiActualDto {
	klic: string;
	hodnota: NastaveniApiValueType;
}

export const isFavoritesDTO = (
	dto: NastaveniApiActualDto
): dto is {
	klic: CommonSettingKey.Favorites;
	hodnota: string[];
} => dto.klic === CommonSettingKey.Favorites;

export const isSearchTermDTO = (
	dto: NastaveniApiActualDto
): dto is {
	klic: CommonSettingKey.SearchTerms;
	hodnota: SearchAllSearchTerms[];
} => dto.klic === CommonSettingKey.SearchTerms;

export const isRecentVisitedDTO = (
	dto: NastaveniApiActualDto
): dto is {
	klic: CommonSettingKey.RecentVisited;
	hodnota: SearchAllRecentVisited[];
} => dto.klic === CommonSettingKey.RecentVisited;

export interface NastaveniSeznamApiActualDto {
	seznam: NastaveniApiActualDto[];
}
